import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import LocalImage from '@/components/Common/LocalImage';
import { InsAccountModel } from '@/types/home';
import { cn } from '@/lib/utils';
interface InstagramUserInfoProps {
  currentInsUser: InsAccountModel;
  className?: string;
  avatarClassName?: string;
  hidePrivateMark?: boolean;
  fullNameClassName?: string;
}

export default function InstagramUserInfo({
  currentInsUser,
  hidePrivateMark = false,
  className,
  avatarClassName,
  fullNameClassName,
}: InstagramUserInfoProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex justify-center items-center gap-4 mt-8 text-center max-md:flex-wrap max-md:justify-start max-md:items-start max-md:gap-2.5',
        className
      )}
    >
      {/* 头像 */}
      <div
        className={cn(
          'w-[4.25rem] h-[4.25rem] rounded-full overflow-hidden max-md:w-[2rem] max-md:h-[2rem]',
          avatarClassName
        )}
      >
        <LocalImage src={currentInsUser.profile_pic_url} alt={currentInsUser.media_name} width={68} height={68} />
      </div>
      <div className="flex gap-4 max-md:flex-1 max-md:block max-md:space-y-1.5">
        <div className="flex items-center gap-3 max-md:gap-2">
          {/* 全名 */}
          <span
            className={cn('text-[1.5rem] leading-7 font-medium max-md:text-[1rem] max-md:leading-5', fullNameClassName)}
          >
            {currentInsUser.full_name || ''}
          </span>
          <a
            className="flex items-center gap-1 text-[#6b7280]"
            href={`https://www.instagram.com/${currentInsUser.media_name}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {/* Instagram 图标 */}
            <div className="w-4 h-4 max-md:w-[1.375rem] max-md:h-[1.375rem]">
              <Image src={'/images/follow/ins-mark.webp'} alt={'ins-mark'} width={22} height={22} />
            </div>
            {/* 账号名 */}
            <span className="leading-4">@{currentInsUser.media_name}</span>
            {/* 蓝标 */}
            {!!currentInsUser.is_verified && (
              <Image src={'/images/follow/blue-mark.webp'} alt={'blue-mark'} width={16} height={16} />
            )}
          </a>
        </div>
        {/* 私密账户图标 */}
        {currentInsUser.is_private === 0 && !hidePrivateMark && (
          <div className="h-8 px-3 leading-8 rounded-full flex items-center gap-1 text-[0.875rem] text-[#0FA733] bg-[#D7EED7] max-md:w-max max-md:h-6 max-md:leading-6 max-md:text-[0.75rem]">
            <div className="w-4 h-4 overflow-hidden max-md:w-3 max-md:h-3">
              <Image src={'/images/follow/private-mark.webp'} alt={'private'} width={15} height={16} />
            </div>
            <span className="leading-4 font-medium">{t('100% anonymous view')}</span>
          </div>
        )}
      </div>
    </div>
  );
}
